import React from "react";
import { Flex, Box, Text, Spinner, Center } from "@chakra-ui/react";

const COLORS = ["red.500", "green.500", "yellow.500", "red.500", "blue.500"];

export function ScoreCards({
  redScore,
  availabilityScore,
  activationScore,
  coolerScore,
  bonusScore,
  loadingScores,
}) {
  const cards = [
    { label: "Average Total RedScore",  value: redScore },
    { label: "Average Availability",    value: availabilityScore },
    { label: "Average Activation",      value: activationScore },
    { label: "Average Cooler",          value: coolerScore },
    { label: "Average Cooler Bonus",    value: bonusScore },
  ];

  return (
    <Flex mt={6} gap={4} flexWrap="wrap">
      {cards.map((card, index) => (
        <Box
          key={card.label}
          bg="white"
          color="gray.800"
          p={4}
          borderRadius="xl"
          textAlign="center"
          borderBottomWidth="6px"
          borderBottomColor="gray.800"
          boxShadow="md"
          _hover={{ boxShadow: "md", transform: "translateY(-2px)" }}
          transition="all 0.2s"
          flex="1"
          minW={{ base: "100%", sm: "45%", md: "auto" }}
        >
          <Text fontSize="sm" fontWeight="medium" color="gray.600">
            {card.label}
          </Text>
          {loadingScores ? (
            <Center h="40px">
              <Spinner size="sm" color={COLORS[index % COLORS.length]} />
            </Center>
          ) : (
            <Text fontWeight="bold" fontSize="xl" color={COLORS[index % COLORS.length]}>
              {`${card.value}`}
            </Text>
          )}
        </Box>
      ))}
    </Flex>
  );
}
